
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ethicalgovernance",
      function () {
        return require("private-next-pages/ethicalgovernance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ethicalgovernance"])
      });
    }
  